<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>Inventory Quoting Rules</strong>
        </div>
        <b-row>
          <b-col md="3" class="my-0" v-if="!hideAllPartners">
            <div style="height: 68vh; overflow: auto">
              <b-list-group>
                <b-list-group-item :id="p.name" v-for="p in partners" button class="d-flex justify-content-between align-items-center" @click="selectPartner(p)" style="padding: 5px 5px 5px 20px;">
                  {{ p.name }}
                  <b-button variant="outline-primary" size="sm" @click="selectPartner(p)">
                    Policies:
                    <b-badge variant="primary" pill>{{ p.policy.length }}</b-badge>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
          <b-col >
            <div v-if="activePartner">
              <b-row style="vertical-align: middle;padding-bottom:5px;">
                <b-col md="12" class="d-inline-flex">
                  <h4>{{ activePartner.name }}</h4> {{selectedPartnerID}}
                  <button id="btnAddNewPolicy" class="btn btn-success" style="margin-left:10px;" @click="createPolicy(activePartner)">
                    <i class="fa fa-plus-square" title="Add a new policy"></i> <strong class="text-white">Add a new policy</strong>
                  </button>
                </b-col>
              </b-row>
              <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                <tbody>
                  <tr v-if="!activePartner.policy.length" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div id="txtNoPoliciesSet" class="text-center my-2">No policies have been set for this partner yet.</div></div></td>
                  </tr>
                  <draggable v-model="activePartner.policy"
                             v-bind="dragOptions"
                             handle=".handle"
                             @start="drag = true"
                             @end="drag = false"
                             item-key="order"
                             @change="orderChanged">
                    <tr v-for="(p, pi) in activePartner.policy" :key="pi">
                      <td>
                        <i class="fa fa-arrows handle" :title="'Drag and drop to change rule display order. ' + p.displayorder"></i>
                      </td>
                      <td>
                        <b-row style="padding-top:5px;padding-bottom:10px;">
                          <b-col md="6" data-toggle="tooltip" :title="p.id"><span class="badge badge-primary">Name:</span> {{ p.name }}</b-col>
                          <b-col md="6"><span class="badge badge-primary">Type:</span> {{ p.typeDescription }}</b-col>
                        </b-row>
                        <b-table v-if="p.vehicleRules" striped small head-variant="light" :items="p.vehicleRules" class="table-xtra-condensed"
                                 :fields="[{key:'newused', label:'Type'},{key:'year', label:'Year'},{key:'make', label:'Make'},{key:'model', label:'Model'},{key:'trim', label:'Trim'},{key:'lotage', label:'Lot Age'}]">
                          <template v-slot:cell(newused)="row">
                            {{ row.value === 1 ? 'New' : 'Used' }}
                          </template>
                        </b-table>
                      </td>
                      <td>
                        <button id="btnEdit" class="btn btn-info text-white" @click="openPolicy(p.id, p.partneridint)">
                          <i class="fa fa-edit" title="Edit"></i> <strong class="text-white">Edit</strong>
                        </button>
                        <button id="btnDelete" class="btn btn-danger text-white" @click="confirmDelete(p.id, pi, p.partneridint)">
                          <i class="fa fa-trash-o" title="Delete"></i>
                        </button>
                      </td>
                    </tr>
                  </draggable>
                </tbody>
              </table>
            </div>
            <div v-else>
              <table class="table b-table table-striped table-hover table-bordered table-sm">
                <tbody class="">
                  <tr class="b-table-empty-row"><td><div role="alert" aria-live="polite"><div class="text-center my-2">Select a partner to define a policy.</div></div></td></tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>
    <b-modal size="xl" ref="addEditPolicyModal" hide-footer title="Add/Edit Policy" show="modalOpen" @hidden="getPolicies" class="policy-modal">
      <quotePolicyDetail :selPolicyID="selectedPolicyID" :selPartnerID="selectedPartnerID" :selPartnerName="selectedPartnerName" :displayOrder="nextDisplayOrder"
                         @clicked="ToggleModal"></quotePolicyDetail>
    </b-modal>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import draggable from 'vuedraggable'
import quotePolicyDetail from '@/views/QuotePolicyDetail'

export default {
  components: {
    loading,
    draggable,
    quotePolicyDetail
  },
  props: ['hideAllPartners'],
  created () {
    this.getPolicies()
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activePartner: null,
      partners: [],
      modalOpen: false,
      selectedPartnerID: 0,
      selectedPartnerName: '',
      selectedPolicyID: -1,
      nextDisplayOrder: 0
    }
  },
  methods: {
    selectPartner (p) {
      this.activePartner = p
      this.activePartner.policy.sort((a, b) => a.displayorder - b.displayorder)
      const displayOrders = this.activePartner.policy.map(rule => rule.displayorder)
      const maxOrder = Math.max(...displayOrders)
      this.nextDisplayOrder = (maxOrder === -Infinity) ? 1 : maxOrder + 1
    },
    orderChanged () {
      var i = 1
      this.activePartner.policy.forEach(quoteRule => {
        quoteRule.displayorder = i++
      })

      this.savePolicies()
    },
    getPolicies () {
      axios.get('/api/quotepolicy/loadlist')
        .then(response => {
          this.boolLoading = false
          this.partners = response.data.data
          if (this.partners) {
            let index = this.partners.findIndex(lastEditedIndex => lastEditedIndex.id === this.selectedPartnerID)
            this.selectPartner(this.partners[index])
          }
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    savePolicies () {

      const promises = []
      this.boolLoading = true

      let quoteOrders = this.activePartner.policy.map(policy => {
        return {
          id: policy.id,
          displayorder: policy.displayorder
        }
      })
      const request = {
        partnerId: this.selectedPartnerID,
        quoteOrders: quoteOrders
      }
      let promise = axios({
        method: 'post',
        url: '/api/quotepolicy/saveorder',
        data: request
      })

      promises.push(promise)
      Promise.all(promises)
        .then(result => {
          console.log('Saved! ' + result)
        })
        .catch(error => {
          console.log('save error: ' + error)
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) {
            this.$router.push('/login')
          }
        })
        .finally(_ => {
          this.boolLoading = false
        })
    },
    createPolicy (p) {
      // window.localStorage.setItem('addquotingpolicy_partneridint', p.id)
      // window.localStorage.setItem('addquotingpolicy_partner', p.name)
      this.selectedPartnerID = p.id
      this.selectedPartnerName = p.name
      this.selectedPolicyID = -1
      this.$refs.addEditPolicyModal.show()
      // this.$router.push('/QuotePolicyDetail/-1')
    },
    openPolicy(policyID, partnerID) {
      this.selectedPartnerID = partnerID
      // this.selectedPartnerName = p.name
      this.selectedPolicyID = policyID
      this.toggleModal = true
      this.$refs.addEditPolicyModal.show()
      // this.$router.push('/QuotePolicyDetail/' + policyID)
    },
    confirmDelete (policyID, policyIndex, partneridint) {
      var ctx = this
      this.$dialog.confirm('Are you sure you would like to proceed?')
        .then(function () {
          ctx.deletePolicy(policyID, policyIndex, partneridint)
        })
        .catch(function () {
          // do nothing
        })
    },
    deletePolicy (policyID, policyIndex, partneridint) {
      this.boolLoading = true
      axios.delete('/api/quotepolicy/save?id=' + policyID + '&partneridint=' + partneridint)
        .then(response => {
          this.boolLoading = false
          Vue.delete(this.activePartner.policy, policyIndex)
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
        })
    },
    ToggleModal: function () {
      this.$refs.addEditPolicyModal.hide()
      this.getPolicies()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  }
}
</script>

<style scoped>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .policy-modal{
      width: 800px;
      height: 600px;
  }

  #btnAddNewPolicy,
  #btnEdit,
  #btnDelete {
    /* border-radius: .25rem; */
  }

  #btnEdit,
  #btnDelete {
    margin-top: 35px;
  }

  #btnAddNewPolicy {
    margin-left: 10px;
    margin-bottom: 15px;
  }

  .handle {
    display: block;
    padding: 15px;
    cursor: ns-resize;
    font-size: 1.4em;
  }

  .ghost {
    opacity: 0.8;
    background: #20a8d8;
  }

</style>



// WEBPACK FOOTER //
// src/views/QuotePolicies.vue